import { z } from 'zod';

export const createRateSchema = z.object({
  name: z.string().min(1, 'validation.nameRequired'),
  notes: z.string().optional().nullable(),
});

export type CreateRateFormData = z.infer<typeof createRateSchema>;
